import { observable, action, reaction } from "mobx";
import agent from "../agent";
import todoList from "../data/todoList";
import { toJS } from "mobx";

class commonStore {
  @observable appName = "blank";
  @observable token = window.localStorage.getItem("ca_token");
  @observable appLoaded = false;
  @observable page = []; // 칼럼 조회 페이지 설정
  @observable mode = 0; // 칼럼 필터링 모드
  @observable filterLength = ""; // 칼럼 검색 후 칼럼 길이
  @observable goal = 0; //목표 바 state
  @observable todo = todoList; // 할 일 목록 state
  @observable activePage = parseInt(localStorage.getItem("currentPage"));
  @observable filterList = {
    titleWriter: "",
    status: 0,
    word: "",
  };
  @observable isUploaded = 0;
  @observable hTagCount = 0;
  @observable wordpressTags = [];
  @observable wordpressCategories = [];

  constructor() {
    reaction(
      () => this.token,
      (token) => {
        if (token) {
          window.localStorage.setItem("ca_token", token);
        } else {
          window.localStorage.removeItem("ca_token");
        }
      }
    );
  }

  @action setToken(token) {
    this.token = token;
  }

  @action setAppLoaded(num) {
    if (num === 1) {
      this.appLoaded = true;
    } else if (num === 2) {
      this.appLoaded = false;
    }
  }

  @action setWordpressTags(tag) {
    this.wordpressTags = tag;
  }

  @action setWordpressCategories(category) {
    this.wordpressCategories = category;
  }

  @action setHTagCount(num) {
    this.hTagCount = num;
  }

  @action setPage(data) {
    // 페이지 셋팅
    this.page = data;
  }

  @action setMode(num) {
    // 칼럼 필터링 셋팅
    this.mode = num;
  }

  @action setActivePage(num) {
    //페이지네이션 셋팅
    this.activePage = num;
  }

  @action setFilterLength(num) {
    //검색 후 칼럼 길이 셋팅
    this.filterLength = num;
  }

  @action setFilterList(tw, state, length) {
    //작성자,제목, 검색어, 진행도 셋팅
    this.filterList = {
      titleWriter: tw,
      status: state,
      word: length,
    };
  }

  @action setIsUploaded(mode) {
    //토스트메세지용 업로드 상태
    this.isUploaded = mode;
  }

  @action setTodo(ver, index) {
    if (ver === 1) {
      //조건에 맞을 때
      this.todo = [...this.todo];
      this.todo[index].onOff = true;
    } else if (ver === 2) {
      //안 맞을 때
      this.todo[index].onOff = false;
    } else {
      //초기화
      for (let i in this.todo) {
        this.todo[i].onOff = false;
      }
    }
    this.goal = 14.29 * this.todo.filter((v) => v.onOff).length; //한 목록 갯수에 따라 색 채우기
  }

  //검색 필터링
  searchWord(word, tw, state) {
    //word: 검색어, tw: 작성자/제목, state: 진행도
    this.setMode(4); // 검색 모드로 변경
    this.setFilterList(tw, state, word); //tw, state, 검색어 길이 값 pagination으로 보내기
    if (word.length === 0) {
      agent.Column.getAll().then((res) => {
        if (state === 0) {
          this.setPage(res.filter((v) => v.state).slice(0, 10)); //진행도 필터링
          this.setFilterLength(res.filter((v) => v.state).length);
        } else {
          this.setPage(res.filter((v) => v.state === state).slice(0, 10)); //진행도 필터링
          this.setFilterLength(res.filter((v) => v.state === state).length);
        }
      });
    } else {
      if (tw === "제목") {
        agent.Column.getAll().then((res) => {
          if (state === 0) {
            this.setPage(res.filter((v) => v.title.includes(word) && v.state).slice(0, 10)); //진행도 필터링
            this.setFilterLength(res.filter((v) => v.title.includes(word)).length);
          } else {
            this.setPage(res.filter((v) => v.title.includes(word) && v.state === state).slice(0, 10)); //진행도 필터링
            this.setFilterLength(res.filter((v) => v.title.includes(word) && v.state === state).length); // 페이지네이션 전체 길이를 구하기 위해 따로 구한다.
          }
        });
      } else if (tw === "작성자") {
        agent.Column.getAll().then((res) => {
          if (state === 0) {
            this.setPage(res.filter((v) => v.writer.includes(word) && v.state).slice(0, 10)); //진행도 필터링
            this.setFilterLength(res.filter((v) => v.writer.includes(word) && v.state).length);
          } else {
            this.setPage(res.filter((v) => v.writer.includes(word) && v.state === state).slice(0, 10)); //진행도 필터링
            this.setFilterLength(res.filter((v) => v.writer.includes(word) && v.state === state).length); // 페이지네이션 전체 길이를 구하기 위해 따로 구한다.
          }
        });
      }
    }

    //선택 시 페이지 저장 초기화 (1로 변경)
    localStorage.setItem("currentPage", 1);
    this.setActivePage(1);
  }

  //agent
  getAllList() {
    // 모든 칼럼 가져오기
    return agent.Column.getAll();
  }

  getPage(category, num) {
    // 칼럼(기사,칼럼) 페이지네이션 가져오기
    return agent.Column.getPage(category, num);
  }

  getAllPage(num) {
    // 모든 칼럼 페이지네이션 가져오기
    return agent.Column.getAllPage(num);
  }

  getMyPage(num) {
    // 본인이 쓴 칼럼 페이지네이션 가져오기
    return agent.Column.getMyPage(num);
  }

  getDetail(id) {
    return agent.Column.getDetail(id);
  }

  delColumn(id) {
    return agent.Column.delete(id);
  }
}
export default new commonStore();
